//Get the Hiistory of Units

export const GET_HISTORY_LIST_ACCOUNTANT = "GET_HISTORY_LIST_ACCOUNTANT";
export const GET_HISTORY_LIST_ACCOUNTANT_SUCCESS =
  "GET_HISTORY_LIST_ACCOUNTANT_SUCCESS";
export const GET_HISTORY_LIST_ACCOUNTANT_FAIL =
  "GET_HISTORY_LIST_ACCOUNTANT_FAIL";
